import React from "react";
import moment from "moment";
import "./ProjectsPageBanner.scss";

type ProjectsPageBannerProps = {
  lastUpdated: string;
};

const ProjectsPageBanner: React.FC<ProjectsPageBannerProps> = ({
  lastUpdated,
}) => {
  return (
    <div className="projects-page-banner">
      <div className="projects-page-banner__content">
        <div className="projects-page-banner__text">
          <h1 className="projects-page-banner__title">Projects</h1>
          <p className="projects-page-banner__subtitle">
            View and manage project solution
          </p>
        </div>
        <div className="projects-page-banner__meta">
          <span className="projects-page-banner__meta-label">LAST UPDATED</span>
          <span className="projects-page-banner__meta-value">
          {moment(lastUpdated, "MMM DD YYYY - hh:mm A").format("DD MMM YYYY - hh:mm A")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProjectsPageBanner;
